import { defaultTheme } from 'evergreen-ui';

export const theme = {
    ...defaultTheme,
    components: {
        ...defaultTheme.components,
        Button: {
            ...defaultTheme.components.Button,
            appearances: {
                ...defaultTheme.components.Button.appearances,
                minimal: {
                    ...defaultTheme.components.Button.appearances.minimal,
                    _hover: {
                        backgroundColor: '#edeff5',
                    },
                },
            },
        },
        Tab: {
            ...defaultTheme.components.Tab,
            appearances: {
                ...defaultTheme.components.Tab.appearances,
                primary: {
                    ...defaultTheme.components.Tab.appearances.primary,
                    _focus: {
                        boxShadow: 'unset',
                    },
                },
            },
        },
    },
};
